<div class="inner cover">
  <h1 class="text-left">Create a new password</h1>
  <p class="text-left login-gray-text login-description">Passwords must be at least 8 characters long and include at least 1 uppercase letter, 1 lowercase letter, 1 number and a special character.</p>
  <form class="reset-password-form" autocomplete="off" (ngSubmit)="onSend(f)" #f="ngForm" (keydown)="onKeyDownFunction($event, f)">
    <div class="form-group">

      <div class="input-group">
        <input
          type="password"
          id="password"
          name="password"
          ngModel
          class="form-control"
          autocomplete="off"
          aria-describedby="passwordHelp"
          placeholder="Password"
          (keyup)="onkeyPassword($event, f)">
        @if (passwordError) {
          <span class="input-group-addon"
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <g fill="none" fill-rule="evenodd">
                <path d="M0 0h24v24H0z"></path>
                <path fill="#FF495C"
                  d="M12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586 9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
                ></path>
              </g>
            </svg>
          </span>
        }
      </div>
      @if (passwordError) {
        <div class="error-container">
          <span class="error-message-small">Invalid password</span>
        </div>
      }

      <div class="input-group">
        <input
          type="password"
          id="password1"
          name="password1"
          ngModel
          class="form-control"
          autocomplete="off"
          aria-describedby="passwordHelp"
          placeholder="Confirm password"
          (keyup)="onkeyPassword1($event, f)">
        @if (password1Error) {
          <span class="input-group-addon"
            >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <g fill="none" fill-rule="evenodd">
                <path d="M0 0h24v24H0z"></path>
                <path fill="#FF495C"
                  d="M12 13.414l2.828 2.829 1.415-1.415L13.414 12l2.829-2.828-1.415-1.415L12 10.586 9.172 7.757 7.757 9.172 10.586 12l-2.829 2.828 1.415 1.415L12 13.414zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z"
                ></path>
              </g>
            </svg>
          </span>
        }
      </div>
      @if (password1Error) {
        <div class="error-container">
          <span class="error-message-small">Passwords don't match</span>
        </div>
      }

    </div>
    <div class="col-xs-12 clearfix">
      <button data-testid="reset-password-confirm" type="submit" class="btn btn-outline-primary btn-outline pull-left active login-button " [disabled]="onInvalid(f)">Confirm</button>
    </div>
  </form>
</div>
